import React, { Component } from 'react'
import styles from './styles.scss'

/** Components */
import LinkUrl from '@/components/LinkUrl'
import LinkPage from '@/components/LinkPage'
import { PopOver } from '@/components/commons/PopOver'
import { connect } from 'react-redux'
import { getTranslation } from '../../../store/getters/language'

class FontLink extends Component {
  state = {
    showOptions: false,
    linkType: 'url',
    url: {
      url: '',
      target: '_blank'
    },
    page: 0
  }

  componentDidMount() {
    const { link } = this.props

    if (!!link && link.page) {
      this.setState(prevState => ({
        ...prevState,
        ...link,
        linkType: 'page',
      }))
    }
    if (!!link && link.url) this.setState({ url: link })

  }

  handleSave = () => {
    const { linkType, url, page } = this.state
    const { onChangeLink } = this.props

    this.setState({ showOptions: false },
      () => onChangeLink(linkType === 'url' ? url : { page })
    )
  }

  render() {
    const { linkType, url, page } = this.state
    const { translation } = this.props

    return (
      <PopOver
        className={'ba-w-100'}
        hidePopover={this.handleSave}
      >
        <div className={'ba-flex ba-jc-se ba-mg-b-1'}>
          <span class={styles[linkType === 'url' ? 'active' : 'inactive']}
            onClick={() => this.setState({ linkType: 'url' })}>
            {translation('general-go-to-url')}
          </span>
          <span class={styles[linkType !== 'url' ? 'active' : 'inactive']}
            onClick={() => this.setState({ linkType: 'page' })}>
            {translation('general-go-to-page')}
          </span>
        </div>
        {linkType === 'url'
          ? <LinkUrl url={url} onChange={url => this.setState({ url })} />
          : <LinkPage page={page} onChange={page => this.setState(page)} />
        }
      </PopOver>
    )
  }
}

const mapStateToProps = (state) => {
  const translation = getTranslation(state)
  return {
    translation
  }
}

export default connect(mapStateToProps)(FontLink) 


// WEBPACK FOOTER //
// ./src/components/editors/FontLink/index.js